import { createContext } from 'react'
import { MediaQueryAllQueryable } from './types'

const Context = createContext<Partial<MediaQueryAllQueryable> | undefined>(
  undefined
)

export default Context
